import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-drums',
    templateUrl: './drums.component.html',
    styleUrls: ['./drums.component.css'],
    standalone: false
})
export class DrumsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
